<template>
  <div class="__label">
    {{ label }}:
  </div>
</template>
<script>

export default {
  props: {
    label: String,
  },
  setup() {
    return {
    }
  },
};
</script>
<style lang="scss">
  .__label {
    font-weight: 500;
    padding-bottom: 10px;
  }
</style>
